// src\themes\mad\elements\Header\HeaderNavMenu.tsx
import { getMainMenu } from "@/core/lib/api/main/menu-api";
import { MenuItem } from "@/core/types/menuApi";
import Link from "next/link";
import { normalizeLink } from "@/core/lib/utils";

export default async function HeaderNavMenu() {
  const mainMenu: MenuItem[] = await getMainMenu();

  return (
    <nav className="gap-8 menu-links hidden justify-center lg:flex w-10/12">
      {mainMenu.map((item) => (
        <Link
          key={item.id}
          href={normalizeLink(item.link)}
          className="text-sm hover:text-primary transition-colors"
        >
          {item.title}
        </Link>
      ))}
    </nav>
  );
}
